import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { TARIFAS } from '../../../../core/enums/tarifas.enum';
import { OfertasService } from '../../services/OfertasService';
import { MessageService } from 'primeng/api';
import { OfertaDtoOut } from '../../models/OfertaDtoOut.model';
import { SkeletonModule } from 'primeng/skeleton';
import { Router } from '@angular/router';
import { APP_ROUTES } from '../../../../core/constants/routes.const';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';

@Component({
  selector: 'app-ofertas-consulta',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    DropdownModule,
    CalendarModule,
    ButtonModule,
    CardModule,
    TooltipModule,
    SkeletonModule,
    DatePipe,
    FloatLabelModule,
    InputText,
  ],
  providers: [MessageService],
  templateUrl: './ofertas-consulta.component.html',
  styleUrl: './ofertas-consulta.component.scss',
})
export class OfertasConsultaComponent implements OnInit {
  private readonly ofertasApi = inject(OfertasService);
  private readonly messages = inject(MessageService);
  private readonly router = inject(Router);

  readonly R = APP_ROUTES;
  readonly T = TARIFAS;

  // MOCK
  fechaDesde?: Date;
  fechaHasta?: Date;
  cups?: string;
  tarifa?: string;
  estado?: string;

  // Opciones mock
  tarifas = [
    { label: 'Todas', value: null },
    { label: TARIFAS.TD20, value: TARIFAS.TD20 },
    { label: TARIFAS.TD30, value: TARIFAS.TD30 },
  ];

  estados = [
    { label: 'Todos', value: null },
    { label: 'Aceptada', value: 'aceptada' },
    { label: 'Rechazada', value: 'rechazada' },
    { label: 'Pendiente', value: 'pendiente' },
  ];

  loading = signal(true);
  ofertas = signal<OfertaDtoOut[]>([]);

  ngOnInit(): void {
    this.cargar();
  }

  cargar() {
    this.loading.set(true);
    this.ofertasApi.getMisOfertas().subscribe({
      next: (data) => this.ofertas.set(data ?? []),
      error: () => {
        this.messages.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudieron cargar las ofertas',
        });
      },
      complete: () => this.loading.set(false),
    });
  }

  limpiar() {
    this.fechaDesde = undefined;
    this.fechaHasta = undefined;
    this.cups = undefined;
    this.tarifa = undefined;
    this.estado = undefined;
  }

  nuevaOferta() {
    this.router.navigate([`/${this.R.OFERTAS.NUEVA}`]).then();
  }

  verDetalle(event: TableRowSelectEvent | OfertaDtoOut) {
    const oferta = (event as TableRowSelectEvent).data ?? (event as OfertaDtoOut);
    this.router.navigate([`/${this.R.OFERTAS.DETALLE(oferta.id)}`]).then();
  }
}
